/** Pure helpers for building the GET /log request — shared by AllLogs and MyLogs. */
import type { FilterForm } from "./logsShared";

export const LOGS_PAGE_SIZE = 50;
/** Mirrors the backend: shorter terms are ignored server-side. */
export const MIN_SEARCH_LENGTH = 2;

export type LogQueryParams = Record<string, string | number>;

export function normalizeSearch(raw: string | undefined): string {
  const term = (raw ?? "").trim();
  return term.length >= MIN_SEARCH_LENGTH ? term : "";
}

/**
 * @param fixedUserId  My Logs pins the user to the logged-in employee and
 *                     ignores any userId on the form.
 */
export function buildLogParams(
  page: number,
  filters: FilterForm | undefined,
  fixedUserId?: string
): LogQueryParams {
  const params: LogQueryParams = { page, limit: LOGS_PAGE_SIZE };
  if (filters?.dateFrom) params.dateFrom = filters.dateFrom;
  if (filters?.dateTo) params.dateTo = filters.dateTo;
  if (filters?.action) params.action = filters.action;
  if (filters?.entity) params.entity = filters.entity;
  if (fixedUserId) params.userId = fixedUserId;
  else if (filters?.userId) params.userId = filters.userId;
  if (filters?.patientId) params.patientId = filters.patientId;
  const search = normalizeSearch(filters?.search);
  if (search) params.search = search;
  return params;
}
